import { render, staticRenderFns } from "./TransactionBookAppointment.vue?vue&type=template&id=2bcc98fe&"
import script from "./TransactionBookAppointment.vue?vue&type=script&lang=ts&"
export * from "./TransactionBookAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports